module.exports = __webpack_public_path__ + "img/model-bg.aca32379.png";